/* eslint-disable
    import/no-webpack-loader-syntax,
*/
require('script-loader!jquery/jquery.validate')
require('script-loader!legacy/jquery.cookie')
require('bootstrap/bootstrap-carousel')
require('etc/new_signup')
require('etc/carousel')
